import { Chip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { REFUND_METHOD, isReturnedTransactionStatus } from '@/utility';

const ReturnedChip = ({ payment }) => {
  const { t } = useTranslation();

  if (
    payment.refund_method !== REFUND_METHOD.INSTANT_PAYMENT ||
    !isReturnedTransactionStatus(payment.transaction_status)
  ) {
    return null;
  }

  return (
    <Chip
      size='small'
      variant='filled'
      color='error'
      label={t('payments.chipLabels.returned')}
    />
  );
};

export default ReturnedChip;
